import React from 'react';

import './BabyweeksBanner.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import { getString } from '../../helpers/styles';

const { LeftArrow, RightArrow } = icons;

export default function BabyweeksBanner(props) {
  const { week } = props;

  return (
    <section id="babyweeksBanner">
      <img
        alt={`week-${week}`}
        src={`/calendar/pregnancy/desktop/${week}.webp`}
      />

      <div id="babyweeksBanner_week">
        {link(
          <span
            className={getString('babyweeksBanner_arrow_hidden', week === 1)}
          >
            <LeftArrow />
          </span>,
          `/week-${week - 1}`
        )}

        <p>Week {week}</p>

        {link(
          <span
            className={getString('babyweeksBanner_arrow_hidden', week === 42)}
          >
            <RightArrow />
          </span>,
          `/week-${week + 1}`
        )}
      </div>
    </section>
  );
}
